import { KEY_LOCAL_STORAGE } from './../const';
import router from './../router';

export default {
  goToHomeWhenLogoff: (key, value) => {
    if (key == KEY_LOCAL_STORAGE.USER_TOKEN && !value) {
      router.push(`/`).catch(() => {});
    }
  },
};
